import React, { useCallback, useEffect, useState } from 'react';
import AdminHeader from 'components/header';
import LayoutContainer from 'components/layout/LayoutContainer';
import Card from 'components/inputs/Card';
import { Col, Row } from 'react-bootstrap';
import { BsSearch } from 'react-icons/bs';
import SearchBox from 'components/general/SearchBox';
import Button from 'components/inputs/Button';
import * as _ from 'lodash';
import PropTypes from 'prop-types';
import { FETCH_WIDGETS } from 'actions/customer';
import { FETCH_CUSTOMERS_WITH_AUTOCHARGE_DISABLED } from 'actions/updateAutochargeActions';
import { useDispatch, useSelector } from 'react-redux';
import ReactPagination from 'components/general/ReactPagination';
import { BiSort } from 'react-icons/bi';
import { cookie } from 'utils/cookies/cookies';
import { MANAGE_CUSTOMERS } from 'components/common/constant';
import { useTranslation } from 'react-i18next';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import Footer from 'components/general/Footer';
import { useLocation } from 'react-router-dom';
import ToggleSwitch from 'components/inputs/ToggleSwitch';
import { UPDATE_VEHICLE } from 'actions/vehicle';
import { UPDATE_STATUS_CODE } from 'components/common/constant';
import { useParams } from 'react-router-dom';

const updateAutochargeSettings = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.includes('/customers/admin');
  const currentUserRole = cookie.get('user-role');
  const { customerId } = useParams();
  const initialSearch = useSelector((state) => state.updateAutocharge.search);
  const customerProfileList = useSelector((state) => state.customerProfile.customerProfile);
  const isDeleted = _.get(customerProfileList, 'deleted');
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState(initialSearch);
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });
  const [pageWiseCustomerData, setPageWiseCustomerData] = useState([]);
  const rolePermissionData = useSelector((state) => state.manageRole.manageRoles);
  const profileData = useSelector((state) => state.profile.userProfile);
  const currentUserName = _.get(profileData, 'name', '');
  const customers = useSelector((state) => state.updateAutocharge.customers);


  const total = useSelector((state) => state.updateAutocharge.total);
  const isLoader = useSelector((state) => state.updateAutocharge.isLoader);
  const page = useSelector((state) => state.updateAutocharge.page);
  const page_no = useSelector((state) => state.updateAutocharge.page_no);
  const totalPages = useSelector((state) => state.updateAutocharge.totalPages);
  const limit = useSelector((state) => state.updateAutocharge.limit);

  const customerData = customers.filter(({ id: id1 }) => pageWiseCustomerData.some(({ id: id2 }) => id2 === id1));


  const getCustomer = useCallback(
    (data = {}) => {
      if (searchText) {
        const customerData = {
          ...data,
          search: searchText,
          ...(isAdminRoute ? { isAdmin: true } : null)
        };
        dispatch({
          type: FETCH_CUSTOMERS_WITH_AUTOCHARGE_DISABLED.REQUEST,
          payload: customerData,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                setPageWiseCustomerData(res.data.results);
              }
            }
          },
        });
      } else {
        const params = isAdminRoute
          ? { ...data, isAdmin: true }
          : { ...data, is_deleted: true };
        dispatch({
          type: FETCH_CUSTOMERS_WITH_AUTOCHARGE_DISABLED.REQUEST,
          payload: params,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                setPageWiseCustomerData(res.data.results);
              }
            }
          },
        });
      }
    },
    [searchText, pageWiseCustomerData, isAdminRoute]
  );


  const getWidgets = useCallback((data = {}) => {
    dispatch({
      type: FETCH_WIDGETS.REQUEST,
      payload: data,
    });
  }, []);

  const autoChargeCustomer = useCallback(
    (data) => {
      dispatch({
        type: UPDATE_VEHICLE.REQUEST,
        payload: data,
        cb: (res) => {
          if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
            getCustomer({ page: 1 });

          }
        },
      });
    },
    [customerId]
  );

  useEffect(() => {
    dispatch({
      type: FETCH_CUSTOMERS_WITH_AUTOCHARGE_DISABLED.REQUEST,
      payload: { page, limit },
    });
  }, [dispatch, page, limit]);


  useEffect(() => {
    getCustomer();
    getWidgets();
  }, []);

  const dataFilter = useCallback(() => {
    if (searchText) {
      const filterDateData = {
        search: searchText,
      };
      getCustomer(filterDateData);
    } else {
      getCustomer();
    }
  }, [searchText, isAdminRoute]);



  const getSortByItem = (name, order, page) => {
    const sortedOrder = order || 'asc';
    if (page) {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      };
      getCustomer(data);
    } else {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
      };
      getCustomer(data);
    }
  };

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };


  const handlePageClick = useCallback(
    (page) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, page);
      } else if (searchText) {
        const data = {
          search: searchText,
          page: page.selected + 1,
        };
        getCustomer(data);
      } else {
        const data = {
          page: page.selected + 1,
        };
        getCustomer(data);
      }
    },
    [sortByItem, searchText]
  );


  const handleSearch = () => {
    const data = {
      search: searchText,
      page: 1,
    };
    getCustomer(data);

  };


  const manageCustomerPermissions =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === MANAGE_CUSTOMERS),
      (data) => data.name
    );


  const getAllEvccIds = (vehicle) => {
    return Object.entries(vehicle)
      .filter(([key, value]) => /^evcc_id(_\d+)?$/.test(key) && Boolean(value))
      .map(([, value]) => value);
  };


  useEffect(() => {
    if (page_no) {
      getCustomer({ page_no });
    }
  }, [page_no]);


  return (
    <>
      <LayoutContainer>
        <AdminHeader title={t('header.updateAutochargeSettings')} />
        <SkeletonTheme baseColor="#1b2a38" highlightColor="#15212b" enableAnimation="true">
          <div className="page-content-wrapper scrollable">
            <div className="customer-management-page__main">
              <div className="customer-details--block">

                <Card style={{ border: 'none', borderRadius: 'none' }}>
                  <div className="customer-details-search--block" style={{ border: 'none', borderRadius: 'none' }}>
                    <Row className="align-items-center">
                      <Col xl={10} md={10}>
                        <SearchBox
                          preIcon={<BsSearch />}
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              handleSearch();
                            }
                          }}
                        />
                      </Col>

                      <Col xl={2} md={2}>
                        <div className="customerList-add-boxButton" onClick={dataFilter}>
                          <Button className="customerList-add-box-Btn w-100">{t('button.search')}</Button>
                        </div>
                      </Col>

                      <Col
                        xl={`${currentUserRole === 'super_admin' ? 12 : !_.isEmpty(manageCustomerPermissions) ? 10 : 12}`}
                        md={`${currentUserRole === 'super_admin' ? 12 : !_.isEmpty(manageCustomerPermissions) ? 8 : 12}`}
                      ></Col>
                    </Row>
                  </div>
                </Card>

              </div>
              <div
                className="new-customer-list"
                style={{ backgroundColor: 'none', transform: 'translateY(-30px)', border: 'none', borderRadius: 'none' }}>
                <Card style={{ backgroundColor: 'none', transform: 'translateY(-30px)', border: 'none', borderRadius: 'none' }}>
                  {/* <div className="customer-text">{isLoader ? <Skeleton height={15} width={100} /> : t('addCustomerList.customerDetails')}</div> */}
                  <div className="customer-list-table">
                    <div className="table-responsive">
                      <table className="">
                        <thead>
                          <tr>

                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height="20" width="100" /> : t('customerDetail.srNo')}</span>
                              </div>
                            </th>


                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addCustomerList.customerName')}</span>
                                <span className="ico" onClick={() => handleSorting('name', sortByItem)}>
                                  <BiSort size={15} />
                                </span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addCustomerList.contactDetails')}</span>
                                <span className="ico" onClick={() => handleSorting('phone', sortByItem)}>
                                  <BiSort size={15} />
                                </span>
                              </div>
                            </th>

                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height="20" width="100" /> : t('customerDetail.vehicleName')}</span>
                              </div>
                            </th>

                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height="20" width="100" /> : t('customerDetail.evccId')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height="20" width="100" /> : t('AutoCharge')}</span>
                              </div>
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {isLoader ? (
                            <tr>
                              <td colSpan={6}>
                                <Skeleton height={20} width="100%" />
                              </td>
                            </tr>
                          ) : _.isEmpty(customers) ? (
                            <tr>
                              <td colSpan={6} className="border-0">
                                <div className="empty-data-block">{t('customerList.noData')}</div>
                              </td>
                            </tr>
                          ) : (
                            customers.map((item, index) => {
                              const ownerDetails = item?.ownerDetails?.[0] || {};
                              const customerName = ownerDetails?.name || 'Guest User';
                              const contactPhone = ownerDetails?.phone || '-';
                              const vehicleMake = item?.model || '-';

                              const evccIds = getAllEvccIds(item);

                              const serialNumber = limit * (page - 1) + index;

                              return (
                                <tr key={`customer-${serialNumber}`}>
                                  <td>{serialNumber + 1}</td>
                                  <td>{customerName}</td>
                                  <td>{contactPhone}</td>
                                  <td>{vehicleMake}</td>
                                  <td>

                                    {evccIds.map((id, i) => (
                                      <span
                                        key={i}
                                        style={{
                                          display: 'inline-block',
                                          backgroundColor: '#1b2a38',
                                          color: '#fff',
                                          borderRadius: '4px',
                                          // marginRight: '6px',
                                          fontSize: '0.85rem',
                                          padding: '2px 2px',
                                        }}
                                      >
                                        {id}{i !== evccIds.length - 1 ? ',' : ''}
                                      </span>
                                    ))}



                                  </td>
                                  <td>
                                    <ToggleSwitch
                                      title="Enable/Disable AutoCharge"
                                      checked={_.get(item, 'is_autocharge_enabled')}
                                      onChange={async (e) => {
                                        const isCheck = e.target.checked;
                                        const evccIds = getAllEvccIds(item);
                                        const ownerDetails = item?.ownerDetails?.[0] || {};

                                        const customerData = _.omit(item, [
                                          'is_default',
                                          'year',
                                          'unit_consumed',
                                          'no_of_session',
                                          '_id',
                                          '__v',
                                          'evmasterdata',
                                          'ownerDetails',
                                          'temp_evcc_id',
                                          'temp_evcc_id_date',
                                          'anpr_enabled',
                                          'evcc_id_2_save_date',
                                        ]);

                                        for (const evccId of evccIds) {
                                          const payload = {
                                            ...customerData,
                                            is_autocharge_enabled: isCheck,
                                            id: _.get(item, '_id'),
                                            owner: ownerDetails?._id || item.owner,
                                            model: item.model,
                                            make: item.make,
                                            type: item.type,
                                            vin_num: item.vin_num,
                                            evcatalog: item.evcatalog,
                                            max_charging_capacity: item.max_charging_capacity,
                                            evcc_id: evccId,
                                          };

                                          try {
                                            await autoChargeCustomer(payload);
                                          } catch (error) {
                                            // toast.error('Failed to update autocharge');
                                          }
                                        }
                                      }}
                                      disabled={isDeleted}
                                    />
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(customerData) && (
                    <>

                      <ReactPagination
                        currentPage={page}
                        limit={limit}
                        total={total}
                        handlePageClick={(pageVal) => handlePageClick(pageVal)}
                        totalPages={totalPages}
                        marginPagesDisplayed={1}

                      />
                    </>
                  )}
                </Card>
              </div>

            </div>
          </div>
        </SkeletonTheme>
        {currentUserName === 'CZ Tenant Admin' ? null : <Footer />}
      </LayoutContainer>
    </>
  );
};
export default updateAutochargeSettings;

const CustomerInfoBlock = (props) => {
  const { icon, title, subtitle } = props;
  return (
    <div className="customer-info--box">
      <div className="customer-info-icon">{icon}</div>
      <div className="customer-info--wrapper">
        <div className="total-customer">{title}</div>
        <div className="info-text">{subtitle}</div>
      </div>
    </div>
  );
};
CustomerInfoBlock.propTypes = {
  icon: PropTypes.object,
  title: PropTypes.number,
  subtitle: PropTypes.string,
};


